import { FC, useCallback } from "react";
import { useAppSelector } from "../../../hooks/hooks";
import { useGetApiQuery } from "../../../services/goroskop";
import EnhancedTable from "./../constituents/Table";

const AdminLineOne : FC = () => {

    const {path, name} = useAppSelector(state => state.adminSlice)

    const { data, error, isLoading, currentData } = useGetApiQuery('moderation.php')

    let newDate = data
    //  Ну я ниче лучше не придумал

    const MemoizedTable = useCallback(() =>
            <>
                {data && (
                    <>
                        <EnhancedTable data={newDate ? newDate : data} nameOfTable={"Линия 1"} />
                    </>
                )}
            </>
        , [currentData])



    return(
        <>
            {error && <h1>oops, error: {JSON.stringify(error)}</h1>}
            {isLoading && <h1>Загрузка, подождите пожалуйста</h1>}
            <MemoizedTable />
        </>
    )
}



export default AdminLineOne